import { commonClass } from "../../helpers/commonClass";
import { history } from "../../helpers/history";
var CryptoJS = require("crypto-js");

function ecrypt(data) {
    var password = 'U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=';
    var encrypted = CryptoJS.AES.encrypt(data, password);
    return encrypted.toString() + "~" + password;
};
var popUpObj = null;
export function IframeLoad(url, no, key, _categoryID, property, messagefunc, freespinflag, freewincount, bonus_id, loading, loaded) {
    //   return sharedFunction("Component2");   
    debugger
    if (property.user == undefined || property.user.mobileNo == "0") {
        messagefunc(property.t('lblplsloginTry'))
        setTimeout(() => {
            history.push("/login");
        }, 2000);
        return;
    }
    if (no == 2) {
        IframeLoadExteral(url, no, key, _categoryID, property, messagefunc, loading, loaded);
        return
    }
    var type = 1;
    var loginKey = property.user.loginKey;
    var userID = property.user.referralid;

    if (url.indexOf("?") == -1 && url.indexOf("html#") == -1) {
        let CurValue = commonClass.GetbaseCurrencyValue()
        let lang_val = ""
        if (JSON.parse(localStorage.getItem('language'))) {
            lang_val = JSON.parse(localStorage.getItem('language'))
        }
        else {
            lang_val = 'en'
        }
        let lang_val_id = commonClass.langidsel(lang_val);
        var datastr = type + "~" + userID + "~" + key + "~" + loginKey + "~" + process.env.REACT_APP_CURRENCY_NAME + "~gulfticket~" + process.env.REACT_APP_CURRENCY_NAME + "~" + 1 + "~" + 1 + "~" + _categoryID + "~" + lang_val + '|' + lang_val_id + "~" + CurValue.currency_value + "~" + property.user.kycstatus + "~" + freespinflag + "~" + freewincount + "~" + bonus_id;
        var data = ecrypt(datastr);
        url = url + "?data=" + data;
    }
    else if (url.indexOf("html#") != -1) {
        var isMobile = window.orientation > -1;
        var ss = isMobile ? 0 : 1;
        var datastr = ecrypt(userID + "~" + loginKey) + "#" + ss;
        url = url + "data=" + datastr;
    }
    if (popUpObj != null) { popUpObj.close(); }
    // history.push({ pathname: '/slotgame', state: { WindowUrl: url, Userid: userID, spintype: freespinflag, gameid: key, type: no } })
    let _formobj = { url: url, userid: userID, gameid: key, type: no };
    localStorage.setItem('slotgame', JSON.stringify(_formobj));
    history.push('/slotgame')
}





function IframeLoadExteral(url, no, key, _categoryID, property, messagefunc, loading, loaded) {
    debugger
    let urlArr = url.split('~');
    if (urlArr.length < 2) {
        messagefunc('Invalid Url Data')
        return
    }
    url = urlArr[0];
    if (property.user == undefined || property.user.mobileNo == "0") {
        messagefunc(property.t('lblplsloginTry'))
        setTimeout(() => {
            history.push("/login");
        }, 2000);
        return;
    }
    let _eplayid = property.user.referralid;
    let _lang = property.i18n.language;
    let secureLogin = urlArr[1];
    let _gsymbol = key;
    let _ptoken = property.user.Usertoken;

    // pragmaticUrl(secureLogin, key)

    //should be albha Order
    let payload = {
        "externalPlayerId": "CG140562",
        "language": "en",
        "secureLogin": "ggmcptlmt_gigco",
        "symbol": "vs20olympgold",
        "token": "8521478582585"
    }
    let message = "externalPlayerId=" + _eplayid + "&language=" + _lang + "&secureLogin=" + secureLogin + "&symbol=" + key + "&token=" + _ptoken + "";
    //let message = "externalPlayerId=CG140562&language=en&secureLogin=ggmcptlmt_gigco&symbol=vs20olympgold&token=8521478582585";
    let secretKey = "ZyaDOd715iZ1VfEL";
    // Compute MD5 hash using CryptoJS
    var hash = CryptoJS.MD5(message + secretKey);
    // Convert to lowercase hexadecimal string
    var hashHex = hash.toString(CryptoJS.enc.Hex);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    const urlencoded = new URLSearchParams();
    urlencoded.append("secureLogin", secureLogin);
    urlencoded.append("symbol", _gsymbol);
    urlencoded.append("language", _lang);
    urlencoded.append("token", _ptoken);
    urlencoded.append("externalPlayerId", _eplayid);
    urlencoded.append("hash", hashHex);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow"
    };

    let urlcheck = process.env.REACT_APP_PRAGMATIC_API + "game_url"
    if (loading) {
        loading();
    }
    fetch(process.env.REACT_APP_PRAGMATIC_API + "game_url", requestOptions)
        .then((response) => response.text())
        .then((result) => {
            if (popUpObj != null) { popUpObj.close(); }
            let jstr = JSON.parse(result);
            jstr = JSON.parse(jstr.response);
            if (jstr.error == "0") {
                // history.push({ pathname: '/slotgame', state: { WindowUrl: jstr.gameURL, Userid: _eplayid, gameid: key, type: no } })
                let _formobj = { url: jstr.gameURL, userid: _eplayid, gameid: key, type: no };
                localStorage.setItem('slotgame', JSON.stringify(_formobj));
                history.push('/slotgame')
            }
            else {
                messagefunc(jstr.description);
            }
        })
        .catch((error) => {
            console.error(error);
            messagefunc("Something Wrong Please Try Again...");
        })
        .finally(() => {
            if (loaded) {
                loaded()
            }
        });
}